export function fieldAsMaybeTextArray(s: unknown): string[] | undefined {
    if (typeof s === "string") return [s];
    if (!Array.isArray(s)) return undefined;
    const arrayEntries = s.filter(i => typeof i === "string");
    return arrayEntries.length === 0 ? undefined : arrayEntries;
}
